import { createFileRoute } from '@tanstack/react-router';

import { ProjectCreate } from '@/module/Author/Project/ProjectCreate';

export const Route = createFileRoute('/_auth/author/_author/project/_project/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ProjectCreate />;
}
